// @core/api/endpoints/task/update_task_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskNumberingSchemeResponse,
  UpdateTaskNumberingSchemeRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update numbering scheme
 * Updates a task numbering scheme. Existing task numbers are not affected.
 */
export async function UpdateTaskNumberingScheme(
  scheme_id: string,
  data: UpdateTaskNumberingSchemeRequest,
  options?: RequestOptions
): Promise<TaskNumberingSchemeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.put<TaskNumberingSchemeResponse>(requestPath, data, requestOptions);
}
